import React, { Component } from "react";

import { Link } from "react-router-dom";

import { Element } from "react-scroll";

const heightStyle = {
  height: '110%'
}

export default class Essencia extends Component {
  render() {
    return (
      <section id="essencia">
        <Element name="essenciaElement" />
        <h1>Essência</h1>

        <div className="section-background">
          <div className="container">
            <div className="row">
              <div className=" col-12 col-lg-5 offset-lg-7">
                <p className="background-texto-principal">
                  Conheça a nossa essência
                </p>

                <div style={heightStyle} className="bottom-align-background" >
                  <p className="background-texto-secundario">
                    A nossa aldeia é rica em histórias de perseverança das suas gentes, de tradições que se mantêm no tempo, de pessoais genuínas que carregam o pesar dos anos de trabalho nas costas.
                    Conheça a nossa essência.
                  </p>
                  <Link to="/essencia">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-above-image"
                    >
                      <span>Descubra!</span>
                    </button>
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
